import moment from 'moment';

export const fetchingState = {
  FETCHING: 'fetching',
  SAVING: 'saving',
  LOADED: 'loaded',
  ERROR: 'error',
};
export const DEFAULT_RPM_PARAM = {
  rpm: 0.0,
};
export const DEFAULT_CPM_PARAM = {
  cpm: 1.05,
};
export const PERMISSION_DENIED = 'permission-denied';
export const SUBSCRIPTION_EXPIRED =
  'Your paid subscription has expired. Please renew to resume service.';

export const SHOW_FILTER_OPTIONS = [
  { label: 'Show all', value: null },
  { label: 'Hide passed loads', value: -2 },
  { label: 'Show loads with no feedback', value: 0 },
  { label: 'Show saved loads only', value: 1 },
  { label: 'Show passed loads only', value: -1 },
];

export const PICK_UP_DATE_FILTER_OPTIONS = [
  { label: 'Any', value: 0 },
  { label: 'Today', value: 1 },
  { label: 'Next 7 Days', value: 7 },
];

export const viewedLinkColorStyle = {
  color: '#292d34 !important',
};

export const HARD_CODE_FEATURE_DATE = moment.utc(
  '08/20/2019 13:05:19',
  'M/D/YYYY H:mm',
);

export const HARD_CODE_NEW_SEARCH_LOADS_FEATURE_DATE = moment.utc(
  '09/23/2019 21:50:14',
  'M/D/YYYY H:mm',
);

export const SUBSCRIPTION_TYPES = {
  1: 'LITE',
  2: 'PLUS',
  3: 'PRO',
};

export const USA = 'USA';
export const UNITED_STATES = 'United States';

export const USA_REGION_EXPANSION = [
  'Midwest',
  'Southwest',
  'Southeast',
  'Northeast',
  'Pacific',
  'Mountain',
];

export const REGION_TOKEN_LIMIT = 6;
export const REGION_TOKEN_DST_LIMIT = 2;

export const CAPACITY_DATA_SOURCE = 'C';
export const EMAIL_DATA_SOURCE = 'E';
export const DIRECT_DATA_SOURCE = 'D';
export const SEARCH_DATA_SOURCE = 'S';
export const EXPIRED_SUBSCRIPTION_HEADING = 'No active paid subscription';
export const EXPIRED_SUBSCRIPTION_BODY = `Your account is not currently enabled for a paid subscription.
            Please start or renew your subscription to re-enable this
            functionality.`;
export const NEW_SEARCH_LOADING_MODAL_TIME_LIMIT = 3;

export const NEW_SEARCH_LOADING_TIME_LIMIT = 3 * 60;
export const NEW_SEARCH_BROKER_LOADING_TIME_LIMIT = 30;

export const STRATEGIES = {
  DIRECT: 1,
  MINIMIZE_LOSS: 2,
  TRI_HAUL: 3,
};

export const DEFAULT_USER_DATA = {
  claims: {
    api_token: null,
    carrier_name: null,
    carrier_user: null,
  },
};

export const labels = {
  delivery: 'Desired Delivery',
  origin: 'Origin',
  equipment: 'Equipment',
  dst_date: 'Target Delivery Date',
  label: 'Label',
  src_date: 'Available Date',
  src_time: 'Available Time',
  search: 'Search',
};

export const DEFAULT_EQUIPMENT = { label: 'Van', value: 'Van' };

export const MAX_NUMBER_OF_PARTNER_LOADS = 100;

export const MOBILE_VIEW_BTN = 'mobile-view-btn';

export const PARTNER_OFFERS_ACTION_BTNS = 'partner-action-btns';

export const IDENTITY = 'identity';

export const PARTNER_PUBLIC_LOADS_VIEW_EVENT = 'PartnerPublicLoadsViewEvent';
export const PARTNER_PAGE_VIEW_EVENT = 'PartnerPageViewEvent';
export const SEARCH_PAGE_VIEW_EVENT = 'SearchViewEvent';
export const PARTNER_PAGE_SEARCH_VIEW_EVENT = 'PartnerSearchViewEvent';

export const GLOBAL_SEARCH_PAGE = 'search';
export const PARTNER_SEARCH_PAGE = 'company';

export const PARADE_STREAM_ID = 'PARADE';

export const PUBLIC_LOADS_PARAM = 'all_loads';

export const PUBLIC_LOADS_SEARCH_PARAM = `?tab=${PUBLIC_LOADS_PARAM}`;

export const DISTANCE_MAX_PUBLIC_LOADS = 4000;
export const DISTANCE_MIN_PUBLIC_LOADS = 10;
export const WEIGHT_MAX_PUBLIC_LOADS = 45000;
export const WEIGHT_MIN_PUBLIC_LOADS = 10;

// good test companies to toggle on wwex atg-charlotte
export const CUSTOM_PARTNER_UI_PAINT = new Set(['loadsmith', 'kamway', 'surge', 'transloop']);
